/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:edd1849e-224a-4f60-bfc5-04491a9cd3e5",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_yUgcQUWzi",
    "aws_user_pools_web_client_id": "6ko2uomimshlv9q1cn86dtk4ht",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://wgpv3tqkercrdbdgjpw73naswe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "contentapi",
            "endpoint": "https://ggzua49flk.execute-api.us-east-1.amazonaws.com/stg",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "app-avatar-2021135835-stg",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
